import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Contract} from '../../../shared/interface/contract';
import {InsuranceCompanyService} from '../../../shared/services/insurance-company.service';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {INSURANCE_TYPE_ASSETS, INSURANCE_TYPE_LIFE} from '../../../shared/services/dict.service';
import {ContractInsuranceCompany} from '../../../shared/interface/contract-insurance-company';
import {ContractService} from '../../../shared/services/contract.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {UtilsService} from '../../../shared/services/utils.service';

export interface ContractInsuranceCompaniesAddDialogData {
  contractObject: Contract;
}

@Component({
  selector: 'app-contract-insurance-companies-add-dialog',
  templateUrl: './contract-insurance-companies-add-dialog.component.html',
  styleUrls: ['./contract-insurance-companies-add-dialog.component.scss']
})
export class ContractInsuranceCompaniesAddDialogComponent {

  readonly INSURANCE_TYPE_LIFE = INSURANCE_TYPE_LIFE;
  readonly INSURANCE_TYPE_ASSETS = INSURANCE_TYPE_ASSETS;

  contractObject: Contract;
  currentInsuranceCompanyIds: number[] = [];
  insuranceCompanies: InsuranceCompany[] = [];
  contractInsuranceCompaniesForm: FormGroup;
  insuranceCompaniesControl: FormControl;
  processingRequest = false;
  assetsInsuranceCompanies: Array<InsuranceCompany[]> = [];
  lifeInsuranceCompanies: Array<InsuranceCompany[]> = [];
  completedLife: boolean = false;
  completedAssets: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ContractInsuranceCompaniesAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContractInsuranceCompaniesAddDialogData,
    private insuranceCompanyService: InsuranceCompanyService,
    private fb: FormBuilder,
    private contractService: ContractService,
    private snack: MatSnackBar,
    private utilsService: UtilsService,
  ) {
    this.contractObject = data.contractObject;

    insuranceCompanyService.getAllInsuranceCompanies()
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        this.insuranceCompanies = result.items;
        this.loadAssetsInsuranceCompanies();
        this.loadLifeInsuranceCompanies();
      });

    this.contractInsuranceCompaniesForm = fb.group({
      insuranceCompanies: this.insuranceCompaniesControl = fb.control([]),
    });

    this.contractObject.insuranceCompanies.forEach((contractInsuranceCompany: ContractInsuranceCompany) => {
      this.currentInsuranceCompanyIds.push(contractInsuranceCompany.insuranceCompany.id);
    });
  }

  private loadAssetsInsuranceCompanies(): void {
    const companies = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
      return insuranceCompany.type.key === INSURANCE_TYPE_ASSETS
        && !insuranceCompany.inactive
        && (!insuranceCompany.parent || insuranceCompany.parent.id === insuranceCompany.id)
      ;
    });

    this.assetsInsuranceCompanies = [
      [...companies].splice(0, 9),
      [...companies].splice(9, 10),
      [...companies].splice(19)
    ];
  }

  private loadLifeInsuranceCompanies(): void {
    const companies = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
      return insuranceCompany.type.key === INSURANCE_TYPE_LIFE
        && !insuranceCompany.inactive
        && (!insuranceCompany.parent || insuranceCompany.parent.id === insuranceCompany.id)
      ;
    });

    this.lifeInsuranceCompanies = [
      [...companies].splice(0, 6),
      [...companies].splice(6, 5),
      [...companies].splice(11)
    ];
  }
  isDisabled (insuranceCompany: InsuranceCompany): boolean {
    if (this.contractObject.company.id === 54){
        return true;
    }
    return false;
  }

  save(): void {
    this.processingRequest = true;

    this.contractService.addInsuranceCompanies(this.contractObject.uuid, this.contractInsuranceCompaniesForm.value)
      .subscribe(() => {
        this.snack.open('Załączniki zostały dodane', '', {duration: 2000});
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy dodawaniu załączników wystąpił błąd', error.status.toString(), {
          duration: 2000
        });
        this.processingRequest = false;
      });
  }
  setAllLife(completed: boolean) {
    this.completedLife = completed;
  }
  setAllAssets(completed: boolean) {
    this.completedAssets = completed;
  }
  cancel(): void {
    this.dialogRef.close();
  }
}
